import { css } from "lit";

export default css`
    :host {
        display: block;
        font-family: var(--fields-pane-font-family);
        font-size: var(--fields-pane-font-size);
    }

    .edit-source-data {
        padding: 0 10px;
    }

    .edit-source-data p {
        margin: 8px 0 4px;
        font-size: 12px;
        font-weight: 400;
    }

    .edit-source-data div {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
    }

    .edit-data-source-btn {
        width: 24px;
        height: 24px;
        margin-left: auto;
        margin-right: 6px;
        padding: 4px;
        border: 0;
        background-color: transparent;
        background-size: contain;
        background-repeat: no-repeat;
        background-origin: content-box;
        background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC42ODM1IDAuNTY4OTcxQzExLjQ1NTggLTAuMjAzMjI0IDEyLjcxMjYgLTAuMTg3MzcxIDEzLjQ2NTIgMC42MDQwNThDMTQuMTkxMyAxLjM2Nzc4IDE0LjE3NjIgMi41NzEyIDEzLjQzMSAzLjMxNjM4TDcuNzM2OTQgOS4wMTAzQzcuNTEzMDcgOS4yMzQxNyA3LjIzMDAxIDkuMzg5NTcgNi45MjA5NSA5LjQ1ODNMNC41MzE4NyA5Ljk4OTU3QzQuMzg2MDEgMTAuMDIyIDQuMjMzNjkgOS45Nzc2NyA0LjEyODAzIDkuODcyMDNDNC4wMjIzNyA5Ljc2NjM5IDMuOTc4IDkuNjE0MDkgNC4wMTA0MSA5LjQ2ODIzTDQuNTQ0NDEgNy4wNjQ5MkM0LjYxMTA4IDYuNzY0OSA0Ljc2MTkyIDYuNDkwMTEgNC45NzkyNSA2LjI3MjhMMTAuNjgzNSAwLjU2ODk3MVpNMTIuODMxOCAxLjIwNjI3QzEyLjQxNzggMC43NzA4ODUgMTEuNzI2NCAwLjc2MjE2NCAxMS4zMDE1IDEuMTg2OTdMMTAuOTg2OSAxLjUwMTUzTDEyLjQ5ODQgMy4wMTI5NUwxMi44MTMgMi42OTg0QzEzLjIyMjkgMi4yODg0NSAxMy4yMzEzIDEuNjI2NDIgMTIuODMxOCAxLjIwNjI3Wk0xMC4zNjg5IDIuMTE5NUw1LjU5NzI0IDYuODkwOEM1LjQ5NzQ2IDYuOTkwNTggNS40MjgyIDcuMTE2NzMgNS4zOTc2IDcuMjU0NDhMNS4wMTI1NiA4Ljk4NzM3TDYuNzMxMjMgOC42MDUxOEM2Ljg3ODA3IDguNTcyNTMgNy4wMTI1NiA4LjQ5ODY4IDcuMTE4OTMgOC4zOTIzMkwxMS44ODA0IDMuNjMwOTRMMTAuMzY4OSAyLjExOTVaIiBmaWxsPSIjMjEyMTIxIi8+CjxwYXRoIGQ9Ik0yIDJINy41QzcuNzc2MTQgMiA4IDEuNzc2MTQgOCAxLjVDOCAxLjIyMzg2IDcuNzc2MTQgMSA3LjUgMUgyQzAuODk1NDMxIDEgMCAxLjg5NTQzIDAgM1YxMkMwIDEzLjEwNDYgMC44OTU0MyAxNCAyIDE0SDExQzEyLjEwNDYgMTQgMTMgMTMuMTA0NiAxMyAxMlY2LjVDMTMgNi4yMjM4NiAxMi43NzYxIDYgMTIuNSA2QzEyLjIyMzkgNiAxMiA2LjIyMzg2IDEyIDYuNVYxMkMxMiAxMi41NTIzIDExLjU1MjMgMTMgMTEgMTNIMkMxLjQ0NzcyIDEzIDEgMTIuNTUyMyAxIDEyVjNDMSAyLjQ0NzcyIDEuNDQ3NzIgMiAyIDJaIiBmaWxsPSIjMjEyMTIxIi8+Cjwvc3ZnPgo=");
    }

    .edit-data-source-btn:hover {
        cursor: pointer;
        background-color: var(--fields-pane-edit-button-hover-background);
    }

    .inner-form {
        position: relative;
        padding: 0 10px;
    }

    fields-pane-field[dragging] {
        opacity: 0.4;
    }

    /* translucent, so the bucket frame and the insertion line stay visible under it */
    fields-pane-field.ghost {
        position: absolute;
        left: 12px;
        opacity: 0.5;
        /* the label fades more than the box, so the insertion line reads through it */
        color: rgb(0 0 0 / 50%);
        pointer-events: none;
        z-index: 10;
        box-shadow: 0 2px 6px rgb(0 0 0 / 25%);
    }
`;
